import React from 'react';

export default function QuestionCard({ number, title, description, children }) {
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-primary text-primary-foreground text-sm font-semibold">
          {number}
        </span>
        <h2 className="text-xl sm:text-2xl font-semibold text-foreground leading-tight">
          {title}
        </h2>
        {description && (
          <p className="text-muted-foreground">
            {description}
          </p>
        )}
      </div>
      {children}
    </div>
  );
}